import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Container, FormGroup, Input, Label } from 'reactstrap';
import { getCompanies } from '../actions/Companies';
import { addUserCompanyFilter, changeFieldUpdateUser } from '../actions/Users';
import CompanyAutocomplete from '../components/CompanyAutocomplete';

const UpdateUserForm = ({
  updateUser,
  getCompanies,
  changeFieldUpdateUser,
  setCompanyFilter,
  companyFilter,
  companies,
  userRole,
  role,
  permission,
}) => {
  const token = localStorage.getItem('jwtToken');
  useEffect(() => {
    (async function() {
      if (userRole === 'superAdmin' || userRole === 'companyGroupAdmin') {
        await getCompanies(token, undefined, 'yes');
      }
      if (updateUser.company) {
        const companyName = updateUser.companyName || updateUser.company.name;
        const company = {
          name: 'company',
          value: companyName,
          suggestion: { ...updateUser.company },
        };
        setCompanyFilter(company);
      }
    })();
  }, []);

  const onCompanyFilter = company => {
    setCompanyFilter(company || {});

    if (!company || !company?.value) {
      changeFieldUpdateUser('company', null);
    } else {
      changeFieldUpdateUser('company', company?.suggestion?._id);
    }
  };

  return (
    <Container>
      <FormGroup row>
        <Label for="name" sm={4}>
          Name
        </Label>
        <Col sm={9}>
          <Input
            name="name"
            value={updateUser.name}
            onChange={({ currentTarget }) =>
              changeFieldUpdateUser(currentTarget.name, currentTarget.value)
            }
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="email" sm={4}>
          Email:
        </Label>
        <Col sm={9}>
          <Input
            type="email"
            name="email"
            value={updateUser.email}
            onChange={({ currentTarget }) =>
              changeFieldUpdateUser(currentTarget.name, currentTarget.value.trim())
            }
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="phoneNumber" sm={4}>
          Phone Number:
        </Label>
        <Col sm={9}>
          <Input
            name="phoneNumber"
            placeholder="please specify"
            value={updateUser.phoneNumber}
            onChange={({ currentTarget }) => {
              const reg = /^[+]*[0-9]{1,11}$/g;
              if (reg.test(currentTarget.value)) {
                changeFieldUpdateUser(currentTarget.name, currentTarget.value.trim());
              }
            }}
          />
        </Col>
      </FormGroup>
      {permission && (
        <FormGroup row>
          <Label for="company" sm={4}>
            Company:
          </Label>
          <Col sm={9}>
            {companies && (
              <CompanyAutocomplete
                searchTerm={companyFilter.value || ''}
                placeholder="Select Company..."
                companies={companies}
                onChange={onCompanyFilter}
              />
            )}
          </Col>
        </FormGroup>
      )}
    </Container>
  );
};

const mapStateToProps = state => ({
  userRole: state.AppState.user.role,
  updateUser: state.UIState.users.updateUser,
  companyFilter: state.UIState.users.companyFilter,
  companies: state.AppState.companies.docs,
});

const mapDispatchToProps = dispatch => ({
  getCompanies: (token, pagination, disablePaginate) =>
    dispatch(getCompanies(token, pagination, disablePaginate)),
  setCompanyFilter: filter => dispatch(addUserCompanyFilter(filter)),
  changeFieldUpdateUser: (name, value) => dispatch(changeFieldUpdateUser(name, value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateUserForm);
